import { render, staticRenderFns } from "./newUserTransactions.vue?vue&type=template&id=22a02bdf&scoped=true"
import script from "./newUserTransactions.vue?vue&type=script&lang=js"
export * from "./newUserTransactions.vue?vue&type=script&lang=js"
import style0 from "./newUserTransactions.vue?vue&type=style&index=0&id=22a02bdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a02bdf",
  null
  
)

export default component.exports